import React from 'react';
import {PlusOutlined} from "@ant-design/icons";
import {Button} from "antd";
import {ModalHandler, useExecuteModal} from "../../hooks/useExecuteModal";
import CreateFleetExpensesTransportModal
  from "../modals/fleetExpenses/CreateFleetExpensesTransportModal/CreateFleetExpensesTransportModal";
import FleetExpensesStore from "../../stores/FleetExpensesStore";

const AddFleetExpensesTransport = () => {
  const addHandler: ModalHandler = useExecuteModal();

  return (
    <>
      <Button onClick={addHandler.executeModal} type={"primary"} size={"small"} icon={<PlusOutlined />}>
        Add TC
      </Button>
      <CreateFleetExpensesTransportModal store={FleetExpensesStore} handler={addHandler} />
    </>
  );
};

export default AddFleetExpensesTransport;